import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { FixedDataPicker } from '../fixed-data-picker/FixedDataPicker';
import { IPickerProps } from '../types';

export const taskPrioTranslationKeys: Record<number, string> = {
  10: 'COMMON.LOW',
  0: 'COMMON.LOW', //Gelesen
  11: 'COMMON.NORMAL',
  1: 'COMMON.NORMAL', //Gelesen
  12: 'COMMON.HIGH',
  2: 'COMMON.HIGH', //Gelesen
};

export const READ_PRIORITY_BY_NORMAL_PRIORITY = {
  10: 0,
  11: 1,
  12: 2,
};

export type ITaskPrioPickerProps<TMultiple extends boolean> = IPickerProps<
  { id: number; name: string },
  TMultiple
>;

export function TaskPrioPicker<TMultiple extends boolean>(
  props: ITaskPrioPickerProps<TMultiple>
) {
  const { ...rest } = props;

  const { t } = useTranslation();

  const dataSet = useMemo(() => {
    return [
      {
        id: 10,
        name: t(taskPrioTranslationKeys[10]),
      },
      {
        id: 11,
        name: t(taskPrioTranslationKeys[11]),
      },
      {
        id: 12,
        name: t(taskPrioTranslationKeys[12]),
      },
    ];
  }, [t]);

  return <FixedDataPicker {...rest} dataSet={dataSet} />;
}
